export default __webpack_public_path__ + "static/media/expl_gradcam_01_DE.8897943f.png";